import type { Mission } from '../missions.ts'

export const cisa: Mission = {
  id: "cisa",
  name: "Cybersecurity and Infrastructure Security Agency",
  short: "CISA",
  call: "Cybersecurity",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.cisa.gov/",
  established: 2018,
  palette: {
    primary: "#005288",
    secondary: "#0078ae",
    accent: "#c41230",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_Cybersecurity_and_Infrastructure_Security_Agency.svg",
  },
  motif: "bolt",
  mission: {
    text: "We lead the national effort to understand, manage, and reduce risk to our cyber and physical infrastructure.",
    url: "https://www.cisa.gov/about",
  },
  fact: {
    text: "On November 16, 2018, the President signed the Cybersecurity and Infrastructure Security Agency Act of 2018, which established CISA from the former National Protection and Programs Directorate.",
    url: "https://www.cisa.gov/news-events/alerts/2018/11/19/cybersecurity-and-infrastructure-security-agency",
  },
  seal: {
    file: "public/seals/cisa.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_Cybersecurity_and_Infrastructure_Security_Agency.svg",
  },
  identifier: {
    about: "https://www.cisa.gov/about",
    accessibility: "https://www.cisa.gov/accessibility",
    foia: "https://www.dhs.gov/foia",
    noFear: "https://www.cisa.gov/about/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.dhs.gov/performance-financial-reports",
    privacy: "https://www.cisa.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/cisa-election-briefing.jpg",
        small: "/media/cisa-election-briefing-sm.jpg",
        alt: "Homeland Security leaders stand before a wall-sized map of the United States color-coded by state during an election security briefing at CISA.",
        title: "Election security briefing at the Cybersecurity and Infrastructure Security Agency, Arlington, Virginia, September 17, 2020",
        creator: "U.S. Department of Homeland Security",
        source: "https://commons.wikimedia.org/wiki/File:Acting_Secretary_Wolf_Attends_CISA_Election_Security_Briefing_(50356674597).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/cisa-nccic-floor.jpg",
        small: "/media/cisa-nccic-floor-sm.jpg",
        alt: "Analysts work at rows of computer monitors on the watch floor of the National Cybersecurity and Communications Integration Center.",
        title: "Watch floor of the National Cybersecurity and Communications Integration Center, Arlington, Virginia, March 11, 2016",
        creator: "U.S. Department of Homeland Security",
        source: "https://commons.wikimedia.org/wiki/File:Employee_Engagement_at_the_NCCIC_(26071709761).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
